import React from 'react';
import { Item } from './styles';

interface Props {
  children: React.ReactNode;
}

const FormItem = ({ children }: Props) => {
  return <Item>{children}</Item>;
};
export default FormItem;
